import React, { useState, useEffect } from 'react';
import { Form, InputNumber, Select, Button } from 'antd';
import { Card, CardBody, Row, Col } from 'reactstrap';
import UrlProps from './UrlProps';
import JsonProps from './JsonProps';
import {
    SaveOutlined
} from '@ant-design/icons';
import { THEME } from 'settings/shared/constants';
import { dataSoruce } from 'settings/shared/constants';

const { Option } = Select;

const CardRender = (props) => {

    const [getDataBindtype, setDataBindtype] = useState("URL");
    const [getDataTheme, setDataTheme] = useState("light");
    const [getErrorFlag, setErrorFlag] = useState(false);

    const [form] = Form.useForm();

    useEffect(() => {
        let widgetData = props.widgetItem !== null &&
            props.widgetItem !== undefined &&
            props.widgetItem.widgetData !== null &&
            props.widgetItem.widgetData.length > 0 &&
            props.widgetItem.widgetData[0];
        if (widgetData.hasOwnProperty("bind")) {
            form.setFieldsValue({
                width: widgetData.width,
                theme: widgetData.theme,
                dataFrom: widgetData.dataFrom
            })
            setDataBindtype(widgetData.dataFrom);

        } else {
            form.setFieldsValue({
                width: 20,
                theme: "light",
                dataFrom: "URL"
            })
            setDataBindtype("URL");
        }

    }, [props]);

    const selectAfterWidth = (
        <Select defaultValue="%" style={{ width: 60 }}>
            <Select.Option value="%">%</Select.Option>
            <Select.Option value="px">px</Select.Option>
        </Select>
    );

    const onChangeTheme = (e) => {
        setDataTheme(e)
    };

    const onChangeDataBind = (e) => {
        setDataBindtype(e)
    };

    const onFinish = () => {
        let forms = form.getFieldValue();
        if (forms.hasOwnProperty("bind")) {
            if (getDataBindtype === "URL") {
                if (forms.bind.path !== "") {
                    setErrorFlag(false)
                    onSentSuccessData();
                } else {
                    let forms = form.getFieldValue();
                    forms["isValid"] = false;
                    setErrorFlag(true)
                    props._getLayoutData(props.widgetId, forms);
                }
            } else {
                if (forms.bind.data !== "") {
                    setErrorFlag(false)
                    onSentSuccessData();
                } else {
                    let forms = form.getFieldValue();
                    forms["isValid"] = false;
                    setErrorFlag(true)
                    props._getLayoutData(props.widgetId, forms);
                }
            }
        } else {
            let forms = form.getFieldValue();
            let cardData = props.widgetItem;
            if (cardData.widgetData !== null && cardData.widgetData.length > 0) {
                let dataSoruce = cardData.widgetData[0].bind;
                _getPropsForIndex(0, dataSoruce);
                setErrorFlag(false)
                onSentSuccessData();
            } else {
                forms["isValid"] = false;
                setErrorFlag(true)
                props._getLayoutData(props.widgetId, forms);
            }

        }
    }

    const onFinishFailed = () => {
    }

    const onSentSuccessData = () => {
        let forms = form.getFieldValue();
        forms["isValid"] = true;
        props._getLayoutData(props.widgetId, forms);
    }

    const _getPropsForIndex = (index, dataSource) => {
        let formData = form.getFieldValue();
        formData["widgetType"] = "Card";
        formData["bind"] = dataSource;
        form.setFieldsValue(formData)
    }

    return <Card className="widget-data-card mt-2">
        <CardBody>
            <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
            >
                <Row>
                    <Col className='pr-3'>

                        <Row className='mb-3'>
                            <Col>
                                <Form.Item name="width" className='col m-0 pl-1 w-100' label={<label
                                    className="form-control-label font12"
                                >
                                    Width
                                </label>} rules={[{ required: true, message: 'Please Enter Width!' }]}>
                                    <InputNumber min={20} max={100} className="select-theme-width" />
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item name="theme" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Theme
                                </label>} rules={[{ required: true, message: 'Please Select Theme!' }]}>
                                    <Select className='select-theme-width' defaultValue="light" onChange={onChangeTheme}>
                                        {THEME.map((item, index) => (
                                            <Select.Option key={index} value={item.value}>{item.label}</Select.Option>
                                        ))}
                                    </Select>

                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item name="dataFrom" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Data From
                                </label>} rules={[{ required: true, message: 'Please Choose Data From!' }]}>
                                    <Select className='select-theme-width' onChange={onChangeDataBind}>
                                        {dataSoruce.map((item, index) => (
                                            <Select.Option value={item.value} key={index}>{item.label}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {getDataBindtype === "URL" && <UrlProps widgetIndex={props.widgetIndex} propData={props.widgetItem} _getPropsForIndex={_getPropsForIndex.bind(this)} errorFlag={getErrorFlag} />}
                                {getDataBindtype === "JSON" && <JsonProps widgetIndex={props.widgetIndex} propData={props.widgetItem} _getPropsForIndex={_getPropsForIndex.bind(this)} errorFlag={getErrorFlag} />}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className='mt-4 float-right'>
                    <Form.Item className='pl-2 save-btn-widgets'>
                        <Button htmlType="submit" title='Save' className='settings-save-btn'>
                            <SaveOutlined className='icon-style' /> Save
                        </Button>
                    </Form.Item>
                </Row>
                <Row>
                </Row>
            </Form>
        </CardBody>
    </Card>
}
export default CardRender;